module.exports = __webpack_public_path__ + "media/app/assets/races/tauren_male-ac04833fe55a9c5919111094cdbcbfd1.png";